import { render, staticRenderFns } from "./TableEffect.vue?vue&type=template&id=1dd4671c&"
import script from "./TableEffect.vue?vue&type=script&lang=js&"
export * from "./TableEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports